import CollectionDataGrid from '@/components/CollectionDataGrid'
import { pbUpsert, usePaginatedCollection, pbAddr } from '@/pb'
import { useInputState } from '@/utils'
import {
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  TextField
} from '@mui/material'
import { useEffect, useState } from 'react'

const blockUnblock = (id, blocked) => () => {
  pb.collection('users').update(id, { blocked })
}

const BlockButton = ({ id, blocked }) => (
  <Button
    onClick={blockUnblock(id, !blocked)}
    variant={blocked ? 'contained' : 'text'}
    color={blocked ? 'error' : 'primary'}
  >
    {blocked ? 'Разблокировать' : 'Заблокировать'}
  </Button>
)


const Editor = ({ row, onClose }) => {
  const [name, setName] = useInputState(row?.name)
  const [selectedRoles, setSelectedRoles] = useState(row?.role || [])
  const [roleOptions, setRoleOptions] = useState([])
  const [optionsLoading, setOptionsLoading] = useState(true)

  useEffect(() => {
    fetch(`${pbAddr}/api/select-options/users`)
      .then((res) => res.json())
      .then((data) => {
        setRoleOptions(data.role || [])
        setOptionsLoading(false)
      })
  }, [])

  const handleSave = () => {
    pbUpsert('users', { id: row?.id, name, role: selectedRoles }).then(onClose)
  }

  return (
    <>
      <DialogTitle>Пользователь</DialogTitle>
      <DialogContent className="editorForm">
        <TextField label="Название" value={name} onChange={setName} />
        <FormControl fullWidth margin="normal">
          <InputLabel id="roles-label">Роли</InputLabel>
          <Select
            labelId="roles-label"
            multiple
            value={selectedRoles}
            onChange={(e) => setSelectedRoles(e.target.value)}
            disabled={optionsLoading}
            renderValue={(selected) => (selected).join(', ')}
          >
            {roleOptions.map((role) => (
              <MenuItem key={role} value={role}>
                <Checkbox checked={selectedRoles.indexOf(role) > -1} />
                <ListItemText primary={role} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Отмена</Button>
        <Button onClick={handleSave} variant="contained">
          Сохранить
        </Button>
      </DialogActions>
    </>
  )
}

const rolesRu = new Map([
  ["admin", "Администратор"],
  ["trainer", "Тренер"],
]);

const columns = [
  { field: 'name', headerName: 'Имя', width: 300 },
  { field: 'email', headerName: 'Email', width: 300 },
  {
    field: 'role', headerName: 'Роли', width: 300, renderCell: ({ value, row }) => <>{value.map((val, index) => (
      <span>{rolesRu.get(val)}{index < value.length - 1 ? ", " : ""}</span>

    ))}</>,
  },
  {
    field: 'blocked', headerName: 'Блокировка', width: 200,
    renderCell: ({ id, value }) => <BlockButton id={id} blocked={value} />
  },
]

export default function Users({ title }) {

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  })

  const {
    records: users,
    totalItems,
    loaded,
  } = usePaginatedCollection('users', {
    page: paginationModel.page + 1,
    perPage: paginationModel.pageSize,
    sort: '-created',
  })

  return (
    <CollectionDataGrid
      collectionName={title}
      collection={users}
      columns={columns}
      loading={!loaded}
      editor={Editor}
      serverPagination={true}
      rowCount={totalItems}
      paginationModel={paginationModel}
      onPaginationModelChange={setPaginationModel}
    />
  )
}